<template>
  <div class="text-center">
    <label for="title">
      <h2>{{ this.$t("common.no_project_warning") }}</h2>
    </label>
  </div>
</template>

<script>
export default {
  name: "PageNoProject"
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/PageNotFound/PageNoProject.vue